export default __webpack_public_path__ + "static/media/spinner.d08b317b.svg";